import React, { useState, useEffect, useCallback } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Outlet from './Outlet';
import './style/OutLets.css';

const OutletLets = ({ nearestOutlets, setIsSingleItem, fetchMore, hasMore }) => {
  const [showTop, setShowTop] = useState(false);

  const handleScroll = useCallback(() => {
    const el = document.getElementById('ol-scroll-target');
    const scrollY = el ? el.scrollTop : window.scrollY;
    setShowTop(scrollY > 300);
  }, []);

  useEffect(() => {
    const el = document.getElementById('ol-scroll-target');
    const target = el || window;
    target.addEventListener('scroll', handleScroll, { passive: true });
    return () => target.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToTop = () => {
    const el = document.getElementById('ol-scroll-target');
    if (el) {
      el.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="ol-root">
      <InfiniteScroll
        dataLength={nearestOutlets.length}
        next={fetchMore}
        hasMore={hasMore}
        scrollableTarget="ol-scroll-target"
        loader={
          <div className="ol-loader">
            <div className="ol-loader-dots">
              <span /><span /><span />
            </div>
            <p>Loading more...</p>
          </div>
        }
        endMessage={
          <div className="ol-end">
            <span>🎉</span>
            <p>You've seen them all!</p>
          </div>
        }
      >
        <div className="ol-grid">
          {nearestOutlets.map((outlet, index) => (
            <Outlet
              key={outlet._id || index}
              outlet={outlet}
              index={index}
              setIsSingleItem={setIsSingleItem}
            />
          ))}
        </div>
      </InfiniteScroll>

      <button
        className={`ol-back-top ${showTop ? 'ol-back-top--visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M8 12V4M4 8l4-4 4 4" stroke="currentColor" strokeWidth="1.8"
            strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
};

export default OutletLets;